module.exports = __webpack_public_path__ + "static/img/feedback_log_0.7df7b4d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/feedback_log_0.png
// module id = s/h5
// module chunks = 0